import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export function Stepper({ 
    steps = [], 
    currentStep = 0, 
    onChange,
    className = '' 
}) {
    return (
        <div className={`w-full flex items-center ${className}`}>
            {steps.map((step, index) => {
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;
                const isClickable = !!onChange && (isCompleted || isCurrent);
                
                return (
                    <React.Fragment key={step.id || index}>
                        {/* Step Marker */}
                        <div 
                            className={`relative flex flex-col items-center ${isClickable ? 'cursor-pointer' : ''}`}
                            onClick={() => isClickable && onChange(index)}
                        >
                            <motion.div 
                                layout
                                className={`
                                    w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2 z-10 transition-colors
                                    ${isCompleted ? 'bg-[var(--accent)] border-[var(--accent)] text-white' : 
                                      isCurrent ? 'bg-[var(--bg-surface)] border-[var(--accent)] text-[var(--accent)]' : 
                                      'bg-[var(--bg-surface)] border-[var(--border-strong)] text-[var(--text-tertiary)]'}
                                `}
                            >
                                {isCompleted ? <ObliqueIcon name="check" size={16} /> : index + 1}
                            </motion.div>
                            
                            <div className="absolute top-10 w-24 text-center">
                                <span className={`
                                    text-xs font-medium transition-colors
                                    ${isCompleted || isCurrent ? 'text-[var(--text-primary)]' : 'text-[var(--text-tertiary)]'}
                                `}>
                                    {step.label}
                                </span>
                            </div>
                        </div>

                        {/* Connector Line */}
                        {index < steps.length - 1 && (
                            <div className="flex-1 h-0.5 mx-2 bg-[var(--border-strong)] relative overflow-hidden mt-[-24px]">
                                <motion.div 
                                    className="absolute top-0 left-0 h-full bg-[var(--accent)] origin-left"
                                    initial={{ width: 0 }}
                                    animate={{ width: isCompleted ? '100%' : '0%' }}
                                    transition={{ duration: 0.4, ease: 'easeOut' }}
                                />
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
